import { Typography } from 'antd'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAddNewIssuedCheckContext } from '../index.context'
import { Table } from 'src/app/shared/components'
import { formatNumberWithCommas } from 'src/app/shared/utils'
import dayjs from 'dayjs'
import { FORMAT_DATE } from 'src/app/shared/constants/app.constants'

const IssuedCheckList: React.FC = () => {
  const { t } = useTranslation()
  const { checkList, columnDefs } = useAddNewIssuedCheckContext()

  const rowData = useMemo(
    () =>
      checkList.map((item, index) => ({
        ...item,
        no: index + 1,
        amount: formatNumberWithCommas(parseFloat(item.amount)),
        issuedDate: dayjs(item.issuedDate).format(FORMAT_DATE),
      })),
    [checkList],
  )

  if (checkList.length <= 0) {
    return <div />
  }

  return (
    <div
      style={{
        marginTop: 24,
      }}
    >
      <Typography.Text className='issued-check-list-title'>
        {t('AddNewIssuedCheck:title.issued_check_list')}
      </Typography.Text>
      <Table
        columnDefs={columnDefs}
        rowData={rowData}
        disableTableControl
        displayActionColumn={false}
        handleChooseColumn={async () => {}}
        handleSearch={async () => {}}
        getHeaderName={null}
        autoSizeStrategy={{
          type: 'fitCellContents',
          skipHeader: true,
        }}
      />
    </div>
  )
}

export default IssuedCheckList
